/**
 * Returns an option's value formatted for the ConfigurationState Component
 * @param {Object} confDataForStep 
 *  The configuration data for a specific Step, as extracted from conf like confData.gui.steps.step[n]
 * @param {String} value 
 * @returns {String}
 */
const optionValueForGuiConfigurationState = (confDataForStep, value) => {
    const options = confDataForStep.options;
    try {
        const optionByValue = options.filter(option => (option.value === value))[0];
        return (optionByValue !== undefined && optionByValue !== null)
            ? optionByValue.label
            : value;
    } catch (e) {
        console.error(`No option found for ${ value }`);
    }
}

export {
    optionValueForGuiConfigurationState
}